import type { RefObject } from 'react';
import { Button } from '../components/button';
import { useUiStrings } from '../strings';
import { InfiniteScrollSentinel } from './infinite-scroll-sentinel';

/** What a footer needs from `useInfiniteList` / `usePagedList`. */
export interface PagingState {
  loadMore: () => void;
  hasMore: boolean;
  loadingMore: boolean;
  error?: unknown;
}

/**
 * Sentinel + "Load more" after the last row of a server-paged list: the next page is requested while the end nears,
 * the button is the keyboard / no-IntersectionObserver fallback and the retry after a failed page.
 */
export function PagingFooter({ paging, rowCount, rootRef }: { paging: PagingState | undefined; rowCount: number; rootRef?: RefObject<Element | null> | undefined }) {
  const strings = useUiStrings();
  if (!paging?.hasMore) return null;
  return (
    <InfiniteScrollSentinel rootRef={rootRef} onVisible={paging.loadMore} disabled={paging.loadingMore || paging.error !== undefined} watch={rowCount}>
      <div className="flex justify-center p-2">
        <Button variant="ghost" size="sm" disabled={paging.loadingMore} onClick={paging.loadMore}>
          {paging.loadingMore ? strings.loading : paging.error !== undefined ? strings.retry : strings.loadMore}
        </Button>
      </div>
    </InfiniteScrollSentinel>
  );
}
